var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-toggle",attrs:{"title":_vm.isDark ? '切换到浅色模式' : '切换到深色模式'},on:{"click":_vm.toggleTheme}},[_c('i',{class:_vm.isDark ? 'el-icon-sunny' : 'el-icon-moon'}),_c('span',{staticClass:"theme-label"},[_vm._v(_vm._s(_vm.isDark ? '浅色' : '深色'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }